import React, { useEffect, useState } from 'react';
import SubmissionsTable from './SubmissionsTable';
import { getAllSubmissions } from '../services/api/submissions/getSubmissions';
import { updateSubmissionStatus } from '../services/api/submissions/updateSubmissions';

const ChallengeSubmissions = () => {
    // const initsubmissions = [
    //     {
    //         submit_id: 1,
    //         submitted_at: '2024-09-30T12:34:56Z',
    //         user_id: 101,
    //         challenge_id: 'C-001',
    //         reel_url: 'https://example.com/reel/123',
    //         description: 'Amazing reel on coding!',
    //         status: 'Approved',
    //     },
    //     {
    //         submit_id: 2,
    //         submitted_at: '2024-09-29T10:20:30Z',
    //         user_id: 102,
    //         challenge_id: 'C-002',
    //         reel_url: 'https://example.com/reel/456',
    //         description: 'Creative project presentation',
    //         status: 'Pending',
    //     },
    // ];

    const [submissions, setSubmissions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getAllSubmissions(1).then(response => {
            // console.log(response);
            if (response.error === null) {
                setSubmissions(response.data);
                setIsLoading(false);
            }
        });
    },[]);

    const updateStatus = async (submitId,status) => {
        updateSubmissionStatus(submitId,status).then(response => {
            if (response.error === null) {
                alert('status updated');
            }else{
                alert('status not updated');
            }
        }).finally(() => { return true });
    }

    return (
        <>
        {isLoading?'Loading...':<SubmissionsTable submissions={submissions} onView={()=>{}} onUpdateStatus={updateStatus} />}
        </>
    );
};

export default ChallengeSubmissions;